'use client'

import Link from 'next/link'

import { PageNotFound } from '@/shared/asset'
import { useSession } from '@/shared/lib'
import { Button } from '@/shared/ui'
import { NavigationBarUI } from '@/widgets/navigation-bar'

export default function Error() {
  const session = useSession()
  const isLoggedIn = !!session.data
  const isHost = session.data?.isHost

  return (
    <>
      <NavigationBarUI isLoggedIn={isLoggedIn} isHost={isHost} />
      <div className="flex h-[calc(100vh-72px)] flex-col items-center bg-gray-50 pt-30">
        <PageNotFound className="mb-6 block" />
        <h2 className="typo-headline2 mb-4 font-bold text-black">
          문제가 발생했습니다
        </h2>
        <p className="typo-body1 mb-10 text-center font-normal text-gray-900">
          알 수 없는 오류가 발생했습니다.
          <br />
          잠시 후 다시 시도해 주세요.
        </p>
        <Button
          asChild
          variant="solid"
          color="primary"
          size="large"
          className="w-60"
        >
          <Link href="/">홈으로 이동</Link>
        </Button>
      </div>
    </>
  )
}
